import React, { Component } from "react";
// import { settingsStart, getSettingsSuccess, settingsFailure } from '../../../../../../../src/redux/actions/settings'

// Ajax Methods
import ajaxMethods from "../../../../../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../../../../../api/ajax-endpoints";

// Forms
import ChannelForm from "../Channel/Form/ChannelForm";
import DisbursementChannelAccountForm from "./Form/DisbursementChannelAccountForm";
import {
  disbursedAccountColumns,
  reOrderTableData,
} from "../../../../../../redux/actions/loans";
import { appInsights } from "../../../../../../config/appInsights";

export default class ChannelSettings extends Component {
  //State
  state = {
    loading: false,
    disbursementChannelOptions: [],
    selectedDisbursementId: "",
    bankId: "",
    currency: "",
    currencyOptionsList: [],
    accountNumber: "",
    bankOptionsList: [],
    disburseEdit: false,
    bankName: "",
    error: "",
    accountName: "",
    accountLoading: false,
    selectedDisbursementIdSearch: "",
    disbursementChannelList: [],
    channelAccountsDetails: [],
    reOrderedTableData: [],
    isDursementChanelDojah: false,
  };

  // Life Cycle Hooks
  componentDidMount() {
    this.getDisbursementChannels();
    this.getBankList();
    this.getCurrency();
  }

  // Component Methods
  editModeHandler = (target) => {
    this.setState({ bankId: "", accountNumber: "" });
    let selectedForm = target.dataset["form"];
    // if(this.state.selectedDisbursementId){
    //     this.getDisbursementChannelDetails()

    // }

    this.setState({
      [`${selectedForm}Edit`]: true,
    });
  };

  cancelUpdateHandler = (target) => {
    let selectedForm = target.dataset["form"];

    this.setState({
      [`${selectedForm}Edit`]: false,
      [`${selectedForm}FormCopy`]: this.state[`${selectedForm}Form`],
      accountName: "",
    });
  };

  handleDisburseSelect = (e) => {
    if (e.target.value === "5") {
      this.setState({
        [e.target.name]: e.target.value,
        disburseEdit: false,
        isDursementChanelDojah: true,
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
        disburseEdit: false,
        isDursementChanelDojah: false,
      });
    }
  };
  handleOptionSelect = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // fetch Disbursement channel list
  getDisbursementChannels = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_DISBURSEMENT_CHANNEL_LIST)
      .then((response) => {
        let disbursementChannelList = [];

        if (response.data.length > 0) {
          disbursementChannelList = [...response.data];
        } else {
          disbursementChannelList = [
            {
              code: 0,
              productCategoryName: "No Categories Yet",
            },
          ];
        }
        const disbursementChannelListOptions = disbursementChannelList.map(
          (ecosystem, index) => {
            const { id, channel_name } = ecosystem;
            return (
              <option key={index} id={id} value={id}>
                {channel_name}
              </option>
            );
          }
        );

        this.setState({
          disbursementChannelOptions: disbursementChannelListOptions,
          disbursementChannelList: disbursementChannelList,
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ChannelSettings.js",
          },
        });
      });
  };

  // fetch accounts for a specific disburse channel
  getDisbursementChannelAccounts = () => {
    this.setState({
      loading: true,
      channelAccountsDetails: [],
      reOrderedTableData: [],
    });
    ajaxMethods
      .get(
        ajaxEndpoints.GET_DISBURSEMENT_ACCOUNTS +
          `?disbursement_channel_id=${this.state.selectedDisbursementIdSearch}`
      )
      .then((response) => {
        this.setState({ loading: false });
        if (response.status_code === 200 || response.status_code === 201) {
          if (response.data) {
            this.setState({ channelAccountsDetails: response.data });
            const reOrderedTableData = reOrderTableData(
              disbursedAccountColumns,
              response.data
            );
            this.setState({ reOrderedTableData: reOrderedTableData });
          } else {
            this.setState({ channelAccountsDetails: [] });
          }
        } else {
          this.setState({ channelAccountsDetails: [] });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ChannelSettings.js",
          },
        });
      });
  };

  //get bank list
  getBankList = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_BANK_LIST)
      .then((response) => {
        if (response.status_code === 200 || response.status_code === 201) {
          let bankList = response.data;
          const bankOptionsList = bankList.map((data, index) => {
            return (
              <option value={data.id} key={index}>
                {data.name}
              </option>
            );
          });
          this.setState({ bankOptionsList: bankOptionsList });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ChannelSettings.js",
          },
        });
      });
  };

  getCurrency = () => {
    ajaxMethods
      .get(ajaxEndpoints.CURRENCIES)
      .then((response) => {
        if (response.status_code === 200 || response.status_code === 201) {
          let currencyList = response.data;

          const currencyOptions = currencyList.map((data, index) => {
            return (
              <option value={data.name} key={index}>
                {data.name}
              </option>
            );
          });
          this.setState({ currencyOptionsList: currencyOptions });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ChannelSettings.js",
          },
        });
      });
  };
  //create disbursement channel accounts
  onCreateDisbursementChannelAccount = () => {
    const {
      selectedDisbursementId,
      bankId,
      accountNumber,
      accountName,
      currency,
    } = this.state;
    let disburse;
    if (selectedDisbursementId === "5") {
      disburse = {
        channel_id: Number(selectedDisbursementId),
        currency: currency,
      };
    } else {
      disburse = {
        channel_id: Number(selectedDisbursementId),
        bank_id: Number(bankId),
        account_number: accountNumber,
        account_name: accountName,
      };
    }

    ajaxMethods
      .post(ajaxEndpoints.ADD_DISBURSEMENT_CHANNEL_ACCOUNT, disburse)
      .then((response) => {
        let message = "";
        if (
          response.status_code === 200 ||
          response.status === 200 ||
          response.data.status === 200 ||
          response?.data?.status_code === 201 ||
          response?.status_code === 201 ||
          response?.status === 201 ||
          response?.data?.status === 201
        ) {
          message = response.data.message;
          this.props.onSetToast("success", message);
          this.setState({ disburseEdit: false });
        } else if (response.status === 400) {
          message = response.data.message;
          this.props.onSetToast("error", message);
        } else {
          this.props.onSetToast(
            "warning",
            "Unable to connect to Advancly services"
          );
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ChannelSettings.js",
          },
        });
        //
        this.props.onSetToast(
          "warning",
          "Unable to connect to Advancly services"
        );
      });
  };
  // validate account number
  onAccountNumberInput = (e) => {
    this.setState({ error: false, accountName: "" });
    let number = e.target.value;
    if (this.state.bankId === "") {
      this.setState({ error: `Please select a bank` });
      return;
    }

    this.setState({ accountNumber: number }, () => {
      this.getBankCode();
      if (number.length === 10 && !this.state.accountLoading) {
        this.setState({ accountLoading: true });

        //validate account number and bank name
        let data = {
          bank_code: this.state.bankCode,
          bank_account_num: number,
        };
        this.validateAccount(data);
      }
    });
  };
  // fetch product category list
  getBankCode = () => {
    ajaxMethods
      .get(ajaxEndpoints.GET_BANK_LIST + `?bank_id=${this.state.bankId}`)
      .then((response) => {
        if (response.status_code === 200 || response.status_code === 201) {
          let res = response.data[0];

          this.setState({ bankCode: res.code });
        } else {
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ChannelSettings.js",
          },
        });
      });
  };
  validateAccount = (data) => {
    ajaxMethods
      .post(ajaxEndpoints.VALIDATE_ACCOUNT_NUMBER, data)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          this.setState({
            accountName: response.data.bank_account_name,
            accountLoading: false,
          });
          // response.json()
          //   .then(res => {
          //   })
        } else if (response.status === 400) {
          this.setState({
            error: response.data.message,
            accountLoading: false,
          });
        }
        if (response.status >= 500) {
          this.setState({
            error: "Unable to connect to Advancly services.",
            accountLoading: false,
          });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ChannelSettings.js",
          },
        });
      });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: false,
    });
  };

  render() {
    const { systemFormCopy } = this.state;
    return (
      <div className="GlobalSettings col-sm-12 mt-30">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <ChannelForm
              inputs={systemFormCopy}
              onEditMode={this.editModeHandler}
              onCancelUpdate={this.cancelUpdateHandler}
              onInputChange={this.handleChange}
              disburseEdit={this.state.disburseEdit}
              disbursementChannelOptions={this.state.disbursementChannelOptions}
              selectedDisbursementId={this.state.selectedDisbursementId}
              bankId={this.state.bankId}
              error={this.state.error}
              accountLoading={this.state.accountLoading}
              accountName={this.state.accountName}
              accountNumber={this.state.accountNumber}
              bankOptionsList={this.state.bankOptionsList}
              handleOptionSelect={this.handleOptionSelect}
              handleDisburseSelect={this.handleDisburseSelect}
              onCreateDisbursementChannelAccount={
                this.onCreateDisbursementChannelAccount
              }
              onAccountNumberInput={this.onAccountNumberInput}
              isDursementChanelDojah={this.state.isDursementChanelDojah}
              currency={this.state.currency}
              currencyOptionsList={this.state.currencyOptionsList}
            />
          </div>
          <div className="col-lg-8 col-md-6 col-sm-12">
            <DisbursementChannelAccountForm
              disbursementChannelOptions={this.state.disbursementChannelOptions}
              selectedDisbursementIdSearch={
                this.state.selectedDisbursementIdSearch
              }
              handleOptionSelect={this.handleOptionSelect}
              disbursementChannelList={this.state.disbursementChannelList}
              channelAccountsDetails={this.state.channelAccountsDetails}
              reOrderedTableData={this.state.reOrderedTableData}
              loading={this.state.loading}
              onSearch={this.getDisbursementChannelAccounts}
            />
          </div>
        </div>
      </div>
    );
  }
}
